import React from 'react';
import styles from './headerInfo.module.scss';
import { Info } from 'src/components/landingComponents/typography';

const HeaderInfo = () => {
  return (
    <div className={styles.container}>
      <Info className={styles.info}>
        Система поддержки принятия решений в области медицины на основании
        утвержденных клинических рекомендаций по различным заболеваниям и/или
        состояниям.
      </Info>
    </div>
  );
};

export default HeaderInfo;
